const deviceEventSettings = window.filterEnvironmentDeviceSettings(
  require('cloud-utils/config/events/default.json').deviceEventSettings
)

angular
  .module('surfsightApp.controllers')
  .controller('edgeDangerousDrivingController', [
    '$scope',
    '$rootScope',
    '$log',
    '$state',
    '$timeout',
    '$interval',
    '$location',
    '$http',
    '$filter',
    '$localStorage',
    '$mdDialog',
    '$mdMedia',
    '$mdSidenav',
    '$mdToast',
    '$mdColors',
    'edgeFactory',
    'edgeGroupFactory',
    'leafletData',
    'nominatimLookUp',
    '$stateParams',
    'SystemConstants',
    'UnitSystem',
    'NgTableParams',
    'edgeFactoryV2',
    function (
      $scope,
      $rootScope,
      $log,
      $state,
      $timeout,
      $interval,
      $location,
      $http,
      $filter,
      $localStorage,
      $mdDialog,
      $mdMedia,
      $mdSidenav,
      $mdToast,
      $mdColors,
      edgeFactory,
      edgeGroupFactory,
      leafletData,
      nominatimLookUp,
      $stateParams,
      SystemConstants,
      UnitSystem,
      NgTableParams,
      edgeFactoryV2
    ) {
      const pageLimit = window.deviceReportPaginationLimit
      const groupId = parseInt($stateParams.edge_group_id)
      const deviceId = parseInt($stateParams.edge_id)
      const $translate = $filter('translate')
      const eventType = $stateParams.eventType || 'acceleration'
      const GSENSOR_PREFIX = 'gsensor'
      const isgSensorEvent = eventType.startsWith(GSENSOR_PREFIX)
      const eventSetting = isgSensorEvent
        ? deviceEventSettings.filter(e => e.name.startsWith(GSENSOR_PREFIX))
        : deviceEventSettings.find(e => e.name === eventType)
      $scope.edge_name = ''
      $scope.reportName = ''
      $scope.unit = ''
      const stateName = $state.current.name
      $scope.UnitSystem = UnitSystem

      if ($localStorage.measurementUnits === 1) {
        SystemConstants.unit = 1
        $scope.units = 'speedMi/h'
      } else {
        SystemConstants.unit = 0
        $scope.units = 'speedKm/h'
      }
      let timeFormat = 2
      if ($localStorage.timeFormat) {
        timeFormat = $localStorage.timeFormat
      }
      const initTable = () => {
        $scope.ngDangerousDrivingReportTable = {
          columns: {
            dashcamName: {
              title: $translate('dashcamName')
            },
            event: {
              title: $translate('event')
            },
            time: {
              title: $translate('time')
            },
            speed: {
              title: $translate($scope.units)
            },
            location: {
              title: $translate('location')
            }
          },
          ngTableParams: new NgTableParams(
            {
              noPager: true,
              page: 1, // show first page
              count: pageLimit // count per page
            },
            {
              counts: [],
              filterDelay: 300,
              getData: params => {
                return new Promise((resolve, reject) => {
                  ;(async () => {
                    const {
                      tableRows,
                      totalRecords
                    } = await getEdgeReportsData(
                      params._params.page,
                      params._params.count
                    )
                    params.total(totalRecords)
                    resolve(tableRows)
                  })()
                })
              }
            }
          )
        }
        $scope.reportName = (
          `${$scope.edge_name} ` +
          `${$translate('aggressiveDrivingReport')} ` +
          `(${$rootScope.reportDateRangeFilter.name_formate2}` +
          `${$rootScope.reportDateRangeFilter.current_year}).csv`
        )
          .replace(/ {2}- /g, '-')
          .replace(/ /g, '-')
      }
      const initReport = async () => {
        await initEdgeStatus()
        $timeout(() => {
          initTable()
        })
      }

      const initEdgeStatus = async () => {
        const statuses = await edgeFactory.getDeviceStatuses([$scope.edge.uri])
        if (statuses.length) {
          $scope.edge.standby = statuses[0].standby
          $scope.edge.status = statuses[0].status
        }
      }
      $scope.showSearchOption = () => !deviceId
      $scope.dangerousDrivingReportState = {
        searchText: '',
        page: 1,
        limit: pageLimit,
        totalCount: 0,
        dashcam: []
      }
      if (
        [
          'home.common.reports.edge',
          'home.common.reports.edgereportDashboard'
        ].includes(stateName)
      ) {
        let edge = edgeFactory.list.find(e => e.id === deviceId)
        if (edge) {
          $scope.edge = edge
          $scope.edge_name = $scope.edge.name
          initReport()
        } else {
          const requestId = window.makeId(5)
          $scope.$emit('LOAD_DEVICE_DETAILS_REQUEST', {
            id: deviceId,
            requestId
          })
          $scope.$on('LOAD_DEVICE_DETAILS_SUCCESS', (e, data) => {
            if (data.id === deviceId && data.requestId === requestId) {
              edge = edgeFactory.list.find(e => e.id === deviceId)
              $scope.edge = edge
              $scope.edge_name = $scope.edge.name
              initReport()
            }
          })
        }
      } else if (
        [
          'home.common.reports.edgegroup',
          'home.common.reports.edgegroupreportDashboard'
        ].includes(stateName)
      ) {
        if (groupId === -1) {
          $scope.edge_name = 'Devices'
          initReport()
        } else {
          let group = edgeGroupFactory.list.find(e => e.id === groupId)
          if (group) {
            $scope.edgeGroupDetails = group
            $scope.edge_name = group.name
            initReport()
          } else {
            const requestId = window.makeId(5)
            $scope.$emit('LOAD_GROUP_DETAILS_REQUEST', {
              id: groupId,
              requestId
            })
            $scope.$on('LOAD_GROUP_DETAILS_SUCCESS', (e, data) => {
              if (data.id === groupId && data.requestId === requestId) {
                group = edgeGroupFactory.list.find(e => e.id === groupId)
                $scope.edgeGroupDetails = group
                $scope.edge_name = $scope.edgeGroupDetails.name
                initReport()
              }
            })
          }
        }
      }
      // mobile screens
      if (
        [
          'home.common.reports.edgegroupreportDashboard',
          'home.common.reports.edgereportDashboard'
        ].includes(stateName)
      ) {
        if (!$rootScope.reportDateRangeFilter) {
          // page does not have search filter information. Redirect
          if (groupId) {
            $state.go('home.common.reports.edgegroup', {
              edge_group_id: groupId
            })
          } else {
            $state.go('home.common.reports.edge', { edge_id: deviceId })
          }
        }
      }
      let searchTextTimer
      $scope.trackSearchText = () => {
        if (deviceId) return
        searchTextTimer && $timeout.cancel(searchTextTimer)
        searchTextTimer = $timeout(() => {
          $scope.dangerousDrivingReportState = {
            searchText: $scope.dangerousDrivingReportState.searchText,
            page: 1,
            limit: pageLimit,
            totalCount: 0,
            dashcam: []
          }
          $scope.ngDangerousDrivingReportTable.ngTableParams.reload()
        }, 1500)
      }
      $scope.$on('eventSearchDataResult', (e, data) => {
        reportRequested = false
        $scope.ngDangerousDrivingReportTable.ngTableParams.reload()
      })
      let reportRequested = false
      let dangerousDrivingReportData = []
      const getEdgeReportsData = async (page = 1, limit = null) => {
        if (!reportRequested) {
          await getDangerousReport()
        }
        if (!limit) {
          // all
          limit = dangerousDrivingReportData.length
        }
        const deviceEvents = dangerousDrivingReportData.slice(
          (page - 1) * limit,
          page * limit
        )
        const deviceEventsParsed = deviceEvents.map(deviceEvent => ({
          eventTranslateName: isgSensorEvent
            ? deviceEvent.eventType
            : eventSetting.translate_name,
          name: deviceEvent.name,
          lat: deviceEvent.lat,
          lon: deviceEvent.lon,
          location: '',
          time_string: moment(deviceEvent.time).format(
            timeFormat === 1 ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY hh:mm A'
          ),
          eventData: deviceEvent
        }))
        const deviceEventsLocations = await Promise.all(
          deviceEvents.map(deviceEvent =>
            nominatimLookUp.reverseLookup({
              lat: deviceEvent.lat,
              lon: deviceEvent.lon
            })
          )
        )
        deviceEventsLocations.forEach((locationDetails, index) => {
          deviceEventsParsed[index].location = locationDetails.title || ''
        })
        return {
          tableRows: deviceEventsParsed,
          totalRecords: dangerousDrivingReportData.length
        }
      }
      const getDangerousReport = async () => {
        reportRequested = true
        const startTimeV2 = moment(
          $rootScope.reportDateRangeFilter.date.start
        ).format()
        const endTimeV2 = moment(
          $rootScope.reportDateRangeFilter.date.end
        ).format()
        const edge = edgeFactory.findItemById(deviceId).item
        try {
          const deviceEventsResponse = await edgeFactoryV2.getEventsByImei(
            edge.uri,
            startTimeV2,
            endTimeV2
          )
          let tableRows = []
          if (deviceEventsResponse && deviceEventsResponse.length) {
            tableRows = isgSensorEvent
              ? deviceEventsResponse.filter(e =>
                  e.eventType.startsWith(GSENSOR_PREFIX)
                )
              : deviceEventsResponse.filter(
                  e => e.eventType === eventSetting.v2Name
                )
          }
          dangerousDrivingReportData = tableRows
        } catch (error) {
          console.log('getDangerousReport', error)
          dangerousDrivingReportData = []
        }
      }
      const showEventVideos = async function (_deviceId, deviceEvent) {
        try {
          var edge = edgeFactory.findItemById(_deviceId).item
          // invoking this to get isBlurringEnabled flag to show conceal icon
          const deviceData = edgeFactoryV2.findItemByImei(edge.uri)
          let device
          if (!deviceData.item) {
            device = await edgeFactoryV2.getSingleDevice(
              edge.organizationId,
              edge.uri
            )
          } else {
            device = deviceData.item
          }
          edge.isBlurringEnabled = device.isBlurringEnabled || false
          $mdDialog.show({
            locals: {
              dataFromCaller: {
                edge: edge,
                edge_event: deviceEvent
              }
            },
            controller: 'EdgeEventVideosController',
            templateUrl:
              './templates/edge.event.videos.view.html?t=' + window.webpackHash,
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: true // Only for -xs, -sm breakpoints.
          })
        } catch (error) {
          console.error('showEventVideos', error)
        }
      }
      $scope.dangerousReportRowClicked = eventData =>
        showEventVideos(deviceId, {
          ...eventData,
          edge_setting: eventSetting,
          time_string_formate: moment(eventData.time).format(
            'h:mm:ss A MMM DD YYYY'
          )
        })
      $scope.showReportDateFilter = e => {
        $scope.$emit('SHOW_REPORT_DATE_FILTER_EMIT', { event: e })
      }
      $scope.exportReport = () => {
        $scope.ngDangerousDrivingReportTable.ngTableParams.settings().$loading = true
        const headers = {
          dashcamName: $translate('dashcamName'),
          event: $translate('event'),
          time: $translate('time'),
          speed: $translate($scope.units),
          location: $translate('location')
        }
        const report = $scope.ngDangerousDrivingReportTable.ngTableParams.data.map(
          tableRow => {
            return {
              [headers.dashcamName]: tableRow.name || $scope.edge_name,
              [headers.event]: $translate(tableRow.eventTranslateName),
              [headers.time]: tableRow.time_string,
              [headers.speed]: UnitSystem.value(
                tableRow.eventData.speed,
                'km/h',
                '$v$l'
              ),
              [headers.location]: tableRow.location
            }
          }
        )
        $scope.ngDangerousDrivingReportTable.ngTableParams.settings().$loading = false
        return report
      }
    }
  ])
